export default {
  setAirports(state, payload) {
    state.airports = payload;
  },
};
